export enum MessageActions {
  LANGUAGE_UPDATED = 'LANGUAGE_UPDATED',
  IMAGE_UPDATED = 'IMAGE_UPDATED_OBJECT',
  NOTIFICATION_CREATED = 'NOTIFICATION_CREATED',
  NOTIFICATION_REMOVED = 'NOTIFICATION_REMOVED',
  NOTIFICATION_READ = 'NOTIFICATION_READ',
  SIGNATURE_RECEIVED = 'SIGNATURE_RECEIVED'
}
